module.exports = __webpack_public_path__ + "site-28.jpg?39d77a63150c2d263e4703a1b29980eb";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-28.jpg
 ** module id = 134
 ** module chunks = 0
 **/